import { TAddressElement, TAddressObj } from './types';

const parseAddressComponentsToObject = (components: google.maps.GeocoderAddressComponent[]) => {
  const address = {} as TAddressObj;
  components.forEach(({ long_name, short_name, types }) => {
    types.forEach((type) => {
      const name = short_name || long_name;
      address[type as TAddressElement] = name;
    });
  });
  return address;
};

const formatSubpremise = (subpremise: string | undefined): string | undefined => {
  if (!subpremise) {
    return undefined;
  }

  if (subpremise[0] === '#') {
    return subpremise;
  }

  return `#${subpremise}`;
};

export const formatAddress = ({
  address_components: components,
  geometry,
}: google.maps.places.PlaceResult) => {
  if (components) {
    const addressRawObject = parseAddressComponentsToObject(components);

    /* eslint-disable  @typescript-eslint/naming-convention */
    const {
      route,
      street_number,
      country,
      subpremise,
      postal_code,
      locality,
      postal_town,
      sublocality,
      sublocality_level_1,
      neighborhood,
      administrative_area_level_3,
      administrative_area_level_2,
      administrative_area_level_1,
    } = addressRawObject;
    /* eslint-enable  @typescript-eslint/naming-convention */

    const subpremiseNo = formatSubpremise(subpremise);
    const city =
      locality ||
      postal_town ||
      sublocality ||
      sublocality_level_1 ||
      neighborhood ||
      administrative_area_level_3 ||
      administrative_area_level_2 ||
      '';
    const address = [street_number, route, subpremiseNo].filter((value) => value).join(' ') || city;
    const state = administrative_area_level_1 || '';

    const zip = postal_code || '';

    const { lat, lng: lon } = geometry?.location?.toJSON() ?? {};

    return { address, city, state, zip, country, lat, lon };
  }
  return {};
};
